import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _get from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/get";
import _inherits from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/colorgrid/colortile
 */
import ButtonView from "../button/buttonview";
import checkIcon from "../../theme/icons/color-tile-check.svg";
/**
 * This class represents a single color tile in the {@link module:ui/colorgrid/colorgrid~ColorGridView}.
 *
 * @extends module:ui/button/buttonview~ButtonView
 */

var ColorTileView = /*#__PURE__*/function (_ButtonView) {
  _inherits(ColorTileView, _ButtonView);

  var _super = _createSuper(ColorTileView);

  function ColorTileView(locale) {
    var _this;

    _classCallCheck(this, ColorTileView);

    _this = _super.call(this, locale);
    var bind = _this.bindTemplate;
    /**
     * String representing a color shown as tile's background.
     *
     * @type {String}
     */

    _this.set('color');
    /**
     * A flag that toggles a special CSS class responsible for displaying
     * a border around the button.
     *
     * @type {Boolean}
     */


    _this.set('hasBorder');

    _this.icon = checkIcon;

    _this.extendTemplate({
      attributes: {
        style: {
          backgroundColor: bind.to('color')
        },
        class: ['ck', 'ck-color-grid__tile', bind.if('hasBorder', 'ck-color-table__color-tile_bordered')]
      }
    });

    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ColorTileView, [{
    key: "render",
    value: function render() {
      _get(_getPrototypeOf(ColorTileView.prototype), "render", this).call(this);

      this.iconView.fillColor = 'hsl(0, 0%, 100%)';
    }
  }]);

  return ColorTileView;
}(ButtonView);

export { ColorTileView as default };